import ko from "./ko";
import en from "./en";
import ja from "./ja";
import zh from "./zh";
import type { Translations } from "../types";

const translations: Translations = { ko, en, ja, zh };
export default translations;
